import { msg } from '@lingui/core/macro';

export const SHARED_PASSWORD_CHANGE_ALERT_BANNER = msg`You must change your password when logging in for the first time.`;
export const SHARED_PASSWORD_CHANGE_PASSWORD_REQUIRED = msg`Password cannot be empty.`;
export const SHARED_PASSWORD_CHANGE_PASSWORDS_DO_NOT_MATCH_ERROR = msg`Passwords do not match. Please re-enter the same password in both fields.`;
export const SHARED_PASSWORD_CHANGE_OLD_PASSWORD_INVALID = msg`The current password you entered is incorrect`;
export const SHARED_PASSWORD_CHANGE_NEW_SAME_AS_OLD = msg`New password cannot be the same as Old password`;
export const SHARED_PASSWORD_CHANGE_OLD_SAME_AS_NEW = msg`Old password cannot be the same as New Password`;
export const SHARED_PASSWORD_CHANGE_NETWORK_ERROR = msg`Network error occurred.`;
